import { useState } from "react";

const useSendEmail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendEmail = async (formData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        "https://hlotblayog.execute-api.us-east-2.amazonaws.com/1/sendEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      return true; // Indicating success
    } catch (err) {
      setError(err.message);
      return false; // Indicating failure
    } finally {
      setLoading(false);
    }
  };

  return { sendEmail, loading, error };
};

export default useSendEmail;
